import { render, staticRenderFns } from "./InfoGraphicsBannerTableAction.vue?vue&type=template&id=067c53dc"
import script from "./InfoGraphicsBannerTableAction.vue?vue&type=script&lang=js"
export * from "./InfoGraphicsBannerTableAction.vue?vue&type=script&lang=js"
import style0 from "./InfoGraphicsBannerTableAction.vue?vue&type=style&index=0&id=067c53dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports